import { AuthService } from './services/auth.service';
import { Component, AfterViewChecked, OnInit } from '@angular/core';
import { RoutingStateService } from './services/routing-state.service';
import { GtmService } from './services/gtm.service';
import { MetaTagService } from './services/meta-tag.service';
import { AppDetailsService } from './services/app-details.service';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'sl-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit, AfterViewChecked {
  loadingApplication = true;

  isLoggedIn: boolean | undefined;

  constructor(
    private authService: AuthService,
    routingStateService: RoutingStateService,
    private gtmService: GtmService,
    private metaTagService: MetaTagService,
    private appDetailsService: AppDetailsService,
    private modal: NzModalService
  ) {
    routingStateService.loadRouting();
    // console.log(`*** AppComponent: is constructing...`);
  }

  ngOnInit(): void {
    // console.log(`*** AppComponent: LoadingApplication`);
    this.metaTagService.setDefaultMetaTags()

    // Check if accessing via demo.sealadder and warn about Google OAuth requirement
    if (this.appDetailsService.shouldShowOAuthWarning()) {
      this.modal.info({
        nzTitle: 'Google OAuth Requires localhost',
        nzContent: 'Google OAuth requires redirect URIs to use localhost or proper TLDs (not custom domains like demo.sealadder). To use Google sign-in, please access the application via localhost:5001 instead.',
        nzOkText: 'Redirect to localhost',
        nzOnOk: () => {
          this.appDetailsService.redirectToLocalhost();
        }
      });
    }

    this.authService.isLoggedInChange().subscribe({
      next: (loggedIn) => {
        // console.log(`*** AppComponent: Change isLoggedIn to: ${loggedIn}`);
        this.isLoggedIn = loggedIn;
        this.gtmService.triggerEvent('eventLoggedIn', this.authService.email);
      },
      error: (error) => {
        console.error(`*** AppComponent: error rom isLoggedInChange. Error: ${JSON.stringify(error)}`);
      }
    });
  }

  ngAfterViewChecked(): void {
    this.loadingApplication = false;
  }
}
